import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, useEffect, useRef, useState } from 'react';
import Tooltip from './Tooltip';
const TruncationTooltip = (props) => {
    const [isTruncated, setIsTruncated] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        // Tolerance may be required to prevent detecting truncation when there is none:
        // https://stackoverflow.com/questions/7738117/html-text-overflow-ellipsis-detection
        const tolerance = 2;
        setIsTruncated(ref.current && ref.current.offsetWidth + tolerance < ref.current.scrollWidth);
        return () => {
            setIsTruncated(false);
        };
    }, [ref]);
    const el = cloneElement(props.children, {
        ...props.children.props,
        ref,
    });
    if (isTruncated) {
        return _jsx(Tooltip, { ...props, children: el });
    }
    else {
        return el;
    }
};
export default TruncationTooltip;
//# sourceMappingURL=TruncationTooltip.js.map